import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import notifier from '../../../_utils/notifier';

import {
  getCartOffers,
  deleteCartOffers,
  checkAllCartOffers,
  removeCartCoupon,
  buyCartOffers
} from '../../actions/cart';
import { getCurrentUserBalance } from '../../actions/auth';
import { getVisibleCartOffers } from '../../reducers/cart-selector';
import Sorting from '../common/Filters/Sorting.jsx';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import { MIN_PRICE_USER_PAYMENT, placeholderAmount } from '../../../config';
import { ThreeDots } from '../common/Placeholders.jsx';
import { Page } from '../../hoc/Page.jsx';

import CartInfo from './CartInfo.jsx';
import CartAlert from './CartAlert.jsx';
import CouponForm from '../common/CouponForm/CouponForm.jsx';
import CartButtons from './CartButtons.jsx';
import FilterSet from '../common/Filters/FilterSet.jsx';
import { renderField } from '../common/FormsControls.jsx';
import { required, email } from '../../../_utils/validators';
import asyncCouponValidate from '../common/CouponForm/asyncValidate';
import CheckboxGroup from './CartCheckboxGroup.jsx';
import { getDiscountByAmount } from './utils';


class Cart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      totalPrice: 0,
      totalDiscountTotalPrice: 0,
      offerType: null,
      offers: [],
    };
  }

  componentDidMount() {
    this.props.getCurrentUserBalance();
    this.props.getCartOffers().then(() => { this.setState({ isLoading: false }) });
  }

  componentWillUnmount() { this.props.removeCartCoupon(); }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const checkedList = this.props.list.filter(o => o.is_checked);

    // считаем возможную скидку за кол-во
    const discountByAmount = getDiscountByAmount(checkedList.filter(o => o.original_discount === 0).length);
    // применяемая скидка - максимальная из "за кол-во" и "персональная"
    let discount = Math.max(discountByAmount, this.props.exclusive_discount);

    if (prevProps.list !== this.props.list){
      //  сменился видимый список товаров (+ чек\анчек)
      //  обновляем список Типов отмеченных товаров
      let offerTypesSet = new Set();
      let offerType = null;
      this.props.list.filter(o => o.is_checked).map( o => o.shopoffers_type).forEach(type => offerTypesSet.add(type));
      if (offerTypesSet.size == 1){
        // все выделенные элементы одного типа
        offerType = [...offerTypesSet][0];
        // обновляем значения в форме
        this.props.change('offerType', offerType);
      }

      // обновляем значения в форме
      this.props.change('offers', checkedList.map(o => o.id));

      this.setState({ offerType: offerType });
    }

    if (prevProps.list !== this.props.list || prevProps.coupon !== this.props.coupon){
      this.setState({ offers: this.getOffersApproveDiscount(this.props.list, discount) });
    }

    if (prevState.offers !== this.state.offers){
      //  изменилась скидка товаров
      let checkedOffers = this.state.offers.filter(o => o.is_checked);
      const totalPrice = this.calculateTotalPrice(checkedOffers);
      const totalDiscountTotalPrice = this.calculateDiscountTotalPrice(checkedOffers);
      this.setState({
        totalPrice: totalPrice,
        totalDiscountTotalPrice: totalDiscountTotalPrice,
      })
    }
  }

  getOffersApproveDiscount = (list, discount) => {
    // применяем скидку к отмеченным товарам, продаваемым без скидки
    // для не отмеченных возвращаем изначальные значения
    const currency = this.props.currency;
    let offer_discount = discount;
    let couponUsedIdList = [];
    // если есть купон
    if (this.props.coupon){
      // учитываем только отмеченные товары продаваемые без скидки
      let couponUsedList = list.filter(offer => offer.is_checked && offer.original_discount === 0);
      // если скидка по купону больше чем применяемая
      if (this.props.coupon.value > offer_discount){
        // выделяем список ID товаров к которым может быть применена скидка по купону
        if (this.props.coupon.shopoffers_type){
          //  если у купона указан тип товаров, выбираем только подходящие товары
          couponUsedList = couponUsedList.filter(offer => offer.shopoffers_type === this.props.coupon.shopoffers_type);
        }
        // сортируем список товаров по уменьшению цены
        couponUsedList.sort(function(a, b) {
          return b.price_number - a.price_number;
        });
        // создаем список ID товаров, используемых купон
        couponUsedIdList = couponUsedList.map(offer => offer.id);

        if (this.props.coupon.item_count){
          //  если у купона указано кол-во товаров, отрезаем нужное кол-во товаров
          couponUsedIdList = couponUsedIdList.slice(0, this.props.coupon.item_count);
        }
      }
    }

    const updatedList = list.map(offer => {
      let offer_discount = discount;
      let newOffer = {...offer};
      if (!newOffer.is_checked){
        newOffer.discount = newOffer.original_discount;
        newOffer.discount_price_number = newOffer.original_discount_price_number;
        newOffer.discount_price = currency + newOffer.original_discount_price_number;
      } else {
        // если товар продается без скидки
        if (newOffer.original_discount === 0){
          // если есть купон и товар входит в список тех которые могут его использовать
          if (this.props.coupon && couponUsedIdList.includes(offer.id)){
            // если скидка по купону больше применяемой, то берем ее
            if (this.props.coupon.value > offer_discount) offer_discount = this.props.coupon.value;
          }

          let discount_price_number = parseFloat((newOffer.price_number - newOffer.price_number * offer_discount / 100).toFixed(2));
          newOffer.discount = offer_discount;
          newOffer.discount_price_number = discount_price_number;
          newOffer.discount_price = currency + discount_price_number;
        }
      }
      return newOffer;
    });
    return updatedList;
  };

  calculateTotalPrice = (checkedOffers) => {
    // стоимость выбранных товаров
    if (checkedOffers.length){
      let price = checkedOffers.reduce((sum, { price_number }) => sum + price_number, 0);
      return parseFloat(price.toFixed(2))
    }
    return 0;
  };

  calculateDiscountTotalPrice = (checkedOffers) => {
    // стоимость выбранных товаров, с примененной скидкой
    if (checkedOffers.length){
      let price = checkedOffers.reduce((sum, { discount_price_number }) => sum + discount_price_number, 0);
      return parseFloat(price.toFixed(2))
    }
    return 0;
  };

  handleDeleteCheckedClick = async () => {
    let offers = this.props.list.filter(o => o.is_checked).map(o => o.id);
    const response = await this.props.deleteCartOffers(offers);
    if (response) notifier.success(gettext('Выбранные товары успешно удалены.'));
  };

  render() {
    const { anyTouched, invalid, submitting, handleSubmit } = this.props;
    const { offers, totalPrice, totalDiscountTotalPrice } = this.state;

    const count = this.props.list.length;
    const checkedCount = this.props.list.filter(o => o.is_checked).length;
    const fullPriceCheckedCount = this.props.list.filter(o => o.is_checked && o.original_discount === 0).length;
    const minPriceError = (checkedCount > 0 &&
                           totalDiscountTotalPrice < MIN_PRICE_USER_PAYMENT &&
                           this.props.balance === 0 );

    if (this.state.isLoading) {
      return <ThreeDots/>;
    }

    return <div>
      <CartInfo lang={ this.props.lang }/>
      <CartAlert count={ count }
                 fullPriceCheckedCount={ fullPriceCheckedCount }
                 coupon={ this.props.coupon }
                 exclusiveDiscount={ this.props.exclusive_discount }/>
      <CartButtons count={ count }
                   checkedCount={ checkedCount }
                   onCheckAllClick={ this.props.checkAllCartOffers }
                   onDeleteCheckedClick={ this.handleDeleteCheckedClick }/>
      <FilterSet isLoading={ this.props.isLoading }
                 difficultyFilter={ true }
                 tonalityFilter={ true }
                 typeFilter={ true }
                 authorFilter={ true }
                 list={ this.props.list }
                 colSize={3}/>
      { count > 0 && <Sorting fields={ ['id', 'title', 'discount_price_number', 'discount'] }/> }

      <Form onSubmit={ handleSubmit } className={ anyTouched ? 'was-validate' : '' }>
        { count ? <CheckboxGroup name='offers' list={ offers }/>
                : <p>{ gettext('Список пуст') }</p> }
        <p><hr/></p>
        <Row>
          <Col xs={12} md={6}>
            { gettext('Количество выбранных товаров') }: <span class="text-orange">{ checkedCount }</span>
          </Col>
          <Col xs={12} md={6}>
            { gettext('Стоимость выбранных товаров') }:  {' '}
            <span className={ totalDiscountTotalPrice != totalPrice ? 'card-price__without-discount': '' }>
            { this.props.currency }{ totalPrice }
            </span> {' '}
            <span className={ totalDiscountTotalPrice != totalPrice ? 'card-price__with-discount': 'd-none' }>
              { this.props.currency }{ totalDiscountTotalPrice }
            </span>
            { (totalDiscountTotalPrice != totalPrice) && <>
              <br/>{ gettext('Ваша скидка составляет') }: {' '}
              { this.props.currency }{ (totalPrice - totalDiscountTotalPrice).toFixed(2) }
            </> }
          </Col>
        </Row>
        { minPriceError && <Alert variant="danger" className='mt-3'>
          { gettext('Минимально допустимая к оплате сумма равна') }: { this.props.currency }{ MIN_PRICE_USER_PAYMENT }
        </Alert> }
        <p><hr/></p>
        { !this.props.isAuth && <Field component={ renderField }
           element='input'
           required='required'
           name='email'
           validate={ [required, email] }
           label={ gettext('Адрес электронной почты') }
           placeholder={ gettext('Адрес электронной почты') }
           helptext={ gettext('Введите реальный адрес электронной почты, на него будут отправлены выбранные товары и данные для входа на сайт.') }
        /> }
        <Field component={ CouponForm }
               name='coupon'
               coupon={ this.props.coupon }
               offerType={ this.state.offerType }
               normalize={ value => value.trim().toUpperCase() }
        />
        <p><hr/></p>
        {/* @todo payssion выбор параметров */}
        <div className='mt-3 text-md-right'>
          <Button variant="orange" type="submit" disabled={ submitting || minPriceError || invalid } className='mt-2 mt-md-0'>
            <i className="icon icon-credit-card mr-2"></i> { gettext('Перейти к оплате') }
          </Button>
        </div>
      </Form>
    </div>
  }
}

let mapStateToProps = (state) => {
  return {
    lang: state.auth.lang,
    isAuth: state.auth.isAuth,
    currency: state.auth.currency,
    balance: state.auth.balance,
    exclusive_discount: state.auth.exclusive_discount,

    coupon: state.cart.coupon,
    list: getVisibleCartOffers(state),
  }
};

export default compose(
  connect(mapStateToProps,{
    getCurrentUserBalance,
    getCartOffers, checkAllCartOffers, deleteCartOffers, removeCartCoupon,
    onSubmit: buyCartOffers
  }),
  reduxForm({
    form: 'cartForm',
    initialValues: { offerType: null, offers: [] },
    asyncValidate: asyncCouponValidate,
    asyncBlurFields: ['coupon'],
  }),
  Page
)(Cart)
